import { render, staticRenderFns } from "./table-poptip.vue?vue&type=template&id=6a0b2be0&scoped=true&"
import script from "./table-poptip.vue?vue&type=script&lang=js&"
export * from "./table-poptip.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a0b2be0",
  null
  
)

export default component.exports